<template>
    <span class="cursor-pointer" @click.stop="openPopAp" style="width: 26px;height: 26px;}">
        <svg id="SVGDoc" width="26" height="26" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 26 26">
            <clipPath id="ClipPath1087">
                <path d="M0,13c0,-7.1797 5.8203,-13 13,-13c7.1797,0 13,5.8203 13,13c0,7.1797 -5.8203,13 -13,13c-7.1797,0 -13,-5.8203 -13,-13z" fill="#ffffff"></path>
            </clipPath>
            <path d="M0,13c0,-7.1797 5.8203,-13 13,-13c7.1797,0 13,5.8203 13,13c0,7.1797 -5.8203,13 -13,13c-7.1797,0 -13,-5.8203 -13,-13z" fill="#4c70b5" fill-opacity="1"></path>
            <path d="M0,13c0,-7.1797 5.8203,-13 13,-13c7.1797,0 13,5.8203 13,13c0,7.1797 -5.8203,13 -13,13c-7.1797,0 -13,-5.8203 -13,-13z" fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#4c70b5" stroke-miterlimit="50" stroke-width="4" clip-path="url(&quot;#ClipPath1087&quot;)"></path>
            <path d="M16.46348,9.34012c0,-0.48248 0.39113,-0.8736 0.8736,-0.8736c0.48248,0 0.8736,0.39113 0.8736,0.8736c0,0.48248 -0.39113,0.8736 -0.8736,0.8736c-0.48248,0 -0.8736,-0.39113 -0.8736,-0.8736z" fill="#ffffff" fill-opacity="1"></path>
            <path d="M21.671,9.96284c-0.33375,-0.84981 -0.94575,-2.07596 -1.96609,-3.09146c-1.01672,-1.012 -2.22987,-1.60649 -3.06855,-1.92705c-0.92075,-0.3519 -1.96702,-0.13009 -2.66546,0.56506l-2.4543,2.4428c-0.72753,0.72409 -0.93721,1.83827 -0.52181,2.77249c0.12881,0.28975 0.26891,0.57315 0.41859,0.84697l-5.3867,5.38666c-0.11722,0.11722 -0.18306,0.27619 -0.18306,0.44197v2.74999c0,0.34519 0.27981,0.625 0.625,0.625h2.74999c0.34519,0 0.625,-0.27981 0.625,-0.625v-1.125v0l1.12499,-0.00003c0.34519,0 0.625,-0.27981 0.625,-0.625v-1.12496v0h1.125c0.34519,0 0.625,-0.27981 0.625,-0.625c0,-0.34519 -0.27981,-0.625 -0.625,-0.625h-1.74999c-0.34519,0 -0.625,0.27981 -0.625,0.625v1.12496v0l-1.125,0.00003c-0.34519,0 -0.625,0.27981 -0.625,0.625v1.12499v0h-1.49999v0v-1.86612v0l5.54232,-5.54229c0.20362,-0.20362 0.24178,-0.51997 0.09244,-0.76615c-0.21659,-0.357 -0.41556,-0.7385 -0.59134,-1.1339c-0.20622,-0.46378 -0.10116,-1.01781 0.26144,-1.37871l2.45427,-2.44277c0.3504,-0.34872 0.87534,-0.45994 1.33743,-0.28337c0.72569,0.27737 1.77155,0.78793 2.63299,1.64537c0.86671,0.86262 1.39437,1.92396 1.68437,2.6624c0.18097,0.46087 0.071,0.98447 -0.28015,1.33396l-2.48393,2.4723c-0.36172,0.35997 -0.90159,0.46522 -1.37549,0.26812c-0.39084,-0.16256 -0.76937,-0.35569 -1.125,-0.57397c-0.29415,-0.18056 -0.67903,-0.08844 -0.85959,0.20575c-0.18056,0.29419 -0.08847,0.67906 0.20572,0.85962c0.411,0.25225 0.848,0.47522 1.29881,0.66272c0.94193,0.39184 2.0164,0.18125 2.73733,-0.53628l2.48393,-2.47227c0.70453,-0.70121 0.92506,-1.75193 0.56184,-2.67683z" fill="#ffffff" fill-opacity="1"></path>
        </svg>
         <div class="demo-alignment">
            <vs-popup class="holamundo p-5" :title="item.id +' | '+ item.created_at" :active.sync="popupActive">
                <ul class="mb-8">
                    <li v-for="(item, key,index) in item.keys" :key="index" class="mt-4">
                        <table style="width: 100%;">
                            <tr>
                                <td width="20" valign="top"><b>{{ index+1 }}</b></td>
                                <td>
                                    <p><b>{{ item.name }}</b></p>
                                    <span class="mt-1">{{ key }}</span>
                                    <div v-for="(order, index) in item" :class="(order.order_returned_id > 0 ? (order.order_returned_status === 200 ? 'returned' : 'returned_pending') : '')">
                                        <div v-for="token in order.tokens" classs="mt-2" v-bind:class="'mt-2 order_'+order.order_id+' tokens'">
                                            <p>{{ token.code }}</p>
                                            <span>{{ token.description }}</span>
                                        </div>
                                        <div v-for="link in order.links" classs="mt-2" v-bind:class="'mt-2 order_'+order.order_id+' links'">
                                            <span v-if="link.url === ''">{{ link.description }}</span>
                                            <a v-else :href="link.url" target="_blank">{{ link.description }}</a>
                                        </div>

                                        <div v-if="order.order_returned_id === 0">
                                            <vs-button class="mt-3 mr-5" size="small" color="success" type="filled" @click="activeOrder(order.order_id, index)">
                                                {{ $t('activate') }}
                                            </vs-button>
                                            <vs-button class="mt-3" size="small" color="danger" type="filled" @click="returnOrder(order.order_id, index)">
                                                {{ $t('return') }}
                                            </vs-button>
                                        </div>
                                        <div v-else-if="order.order_returned_id === -1">
                                            <vs-button class="mt-3 mr-5" size="small" color="primary" type="filled" @click="openSendEmailPopUp(order.order_id)">
                                                {{ $t('sendByEmail') }}
                                            </vs-button>

                                            <vs-button v-if="order.mail_logs.length" class="px-2 mr-5" size="small" color="primary" type="filled" @click="openSendedEmailLogPopUp(order.mail_logs)">
                                                @
                                            </vs-button>

                                        </div>

                                        <vs-divider class="d-theme-border-grey-light m-0 mt-3 mb-3" />
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </li>
                </ul>

                <vs-button v-if="item.total_price !== 0" class="ml-5" size="small" color="success" type="filled" @click="activeAllOrder(item.intId)" style="margin-left: 22px;">
                    {{ $t('activateAllKeys') }}
                </vs-button>
                <br>
                <vs-button v-if="item.total_price !== 0" class="ml-5 mt-3" size="small" color="primary" type="filled" @click="openSendEmailPopUp(item.intId, true)" style="margin-left: 22px;">
                    {{ $t('sendAllActivatedByEmail') }}
                </vs-button>
                <br>
                <download-excel
                    v-if="item.total_price !== 0"
                    class   = "btn btn-default"
                    :data   = "json_data"
                    worksheet = "My Worksheet"
                    name = "esd.techprodc.com-keys.xls">
                    <vs-button class="ml-5 mt-3" size="small" color="primary" type="filled">
                        {{ $t('ExportToExcel') }}
                    </vs-button>
                </download-excel>

                <vs-popup class="holamundo p-5" :title="$t('sendByEmail')" :active.sync="sendTokenToEmailPopUp">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('email') }} *</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-input class="w-full" name="mpn_id" v-model="sendTokenToEmailValue"/>
                        </div>
                    </div>

                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full"></div>
                        <div class="vx-col sm:w-2/3 w-full">
                            <vs-button color="success" type="filled" @click="sendTokenToEmail()">{{ $t('SendToken') }}</vs-button>
                        </div>
                    </div>
                </vs-popup>

                <vs-popup class="holamundo p-5" :title="$t('emailAddress')" :active.sync="sendedEmailLogPopUp">
                    <div class="vx-row mb-6">
                        <div class="vx-col sm:w-1/3 w-full">
                            <span>{{ $t('emails') }}</span>
                        </div>
                        <div class="vx-col sm:w-2/3 w-full">
                            {{ mailLogs.map(item => item.email).join(', ') }}
                        </div>
                    </div>
                </vs-popup>
            </vs-popup>
        </div>
    </span>
</template>

<script>
  export default {

      name: "OrderPopup",
      props: ['data'],
      search: {
          type: Object,
          default: {}
      },
      components: {},
      data() {
          return {
            item: this.data,
            popupActive: false,
            sendTokenToEmailPopUp : false,
            sendedEmailLogPopUp : false,
            mailLogs : [],
            sendTokenToEmailValue: '',
            sendTokenToOrderId: 0,
            sendAllTokenToOrderGroupId: 0,
            sendAll: false,

            json_data: [],
            json_meta: [
              [
                  {
                      'key': 'charset',
                      'value': 'utf-8'
                  }
              ]
            ],
          }
      },
      methods: {
          async openPopAp(){
              this.$vs.loading();
              let thisIns = this;
              await axios.get(apiUrl+'/orders/'+this.item.intId+'/keys?token='+token)
                  .then(function (response) {

                      let data = response.data;
                      if(data.code === 200){
                          thisIns.item.keys = data.data;
                      }else{
                          if (data.code === 401){
                              window.logout();
                          }
                          thisIns.$vs.notify({
                              title: 'Error',
                              text:  data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          });
                      }
                  });

              let _return = [
                  {
                      ' ' : '<b>Дата заказа</b>',
                      '  ' : this.item.created_at,
                      '   ' : '',
                      '    ' : '',
                      /*'     ' : '',*/
                  },
                  {
                      ' ' : '<b>Номер заказа</b>',
                      '  ' : this.item.id,
                      '   ' : '',
                      '    ' : '',
                      /*'     ' : '',*/
                  },
                  {
                      ' ' : '',
                      '  ' : '',
                      '   ' : '',
                      '    ' : '',
                      /*'     ' : '',*/
                  },
                  {
                      ' ' : '<b>Парт-номер</b>',
                      '  ' : '<b>Название</b>',
                      '   ' : '<b>Ключ</b>',
                      '    ' : '<b>Ссылка в HTML-формате</b>',
                      /*'     ' : '<b>Ссылка в текстовом формате</b>',*/
                  }
              ];

              if (this.item.keys) {

                  for (let [key, items] of Object.entries(this.item.keys)) {
                      for (let [i, item] of Object.entries(items)) {

                          for (let [index, token] of Object.entries(item.tokens)) {
                              let html = '';
                              let link = '';

                              if (item.links[index] !== undefined) {
                                  let l = item.links[index];
                                  if (l.url !== '') {
                                      link = l.url;
                                      html = '<a href="' + l.url + '" target="_blank">' + l.description + '</a>';
                                  } else {
                                      html = l.description;
                                  }
                              }

                              _return.push({
                                  ' ': key,
                                  '  ': item.product_name,
                                  '   ': token.code,
                                  '    ': html,
                                  /*'     ': link,*/
                              });
                          }

                      }
                  }
                  /*this.item.keys.forEach(function (item, key) {

                      item.tokens.forEach(function (token, index) {
                          let html = '';
                          let link = '';

                          if (item.links[index] !== undefined) {
                              let l = item.links[index];
                              if (l.url !== '') {
                                  link = l.url;
                                  html = '<a href="' + l.url + '" target="_blank">' + l.description + '</a>';
                              } else {
                                  html = l.description;
                              }
                          }

                          _return.push({
                              ' ': key,
                              '  ': item.product_name,
                              '   ': token.code,
                              '    ': html,
                              '     ': link,
                          });
                      });
                  });*/
              }

              this.json_data = _return;
              thisIns.$vs.loading.close();
              this.popupActive = true;
          },
          activeOrder(orderId, index) {
              this.$vs.loading();
              let thisIns = this;
              axios.get(apiUrl + '/order/' + orderId + '/active?token=' + token)
                  .then(function (response) {

                      let data = response.data;
                      if (data.code === 200) {
                          data = data.data;
                          thisIns.item.keys[data.Sku][index] = data.key;
                          thisIns.popupActive = false;
                          thisIns.popupActive = true;
                      } else {
                          if (data.code === 401) {
                              window.logout();
                          }
                          thisIns.$vs.notify({
                              title: 'Error',
                              text: data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          });
                      }

                      thisIns.$vs.loading.close();
                  });
          },
          activeAllOrder(orderGroupId){
              this.$vs.loading();
              let thisIns = this;
              axios.get(apiUrl + '/orders/' + orderGroupId + '/active?token=' + token)
                  .then(function (response) {

                      let data = response.data;
                      if (data.code === 200) {
                          data = data.data;
                          thisIns.item.keys = data;
                          thisIns.popupActive = false;
                          thisIns.popupActive = true;
                      } else {
                          if (data.code === 401) {
                              window.logout();
                          }
                          thisIns.$vs.notify({
                              title: 'Error',
                              text: data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          });
                      }

                      thisIns.$vs.loading.close();
                  });
          },
          openConfirm(orderId, index) {
              this.$vs.dialog({
                  type: 'confirm',
                  color: 'danger',
                  title: this.$t('confirm'),
                  text: 'Are you sure?',
                  accept: ()=>{ this.returnOrder(orderId, index, false) }
              })
          },
          returnOrder(orderId, index, needConfirm = true) {
              if (needConfirm) {
                  this.openConfirm(orderId, index);
                  return false;
              }

              this.$vs.loading();
              let thisIns = this;
              axios.get(apiUrl + '/order/' + orderId + '/return?token=' + token)
                  .then(function (response) {

                      let data = response.data;
                      if (data.code === 200) {
                          if (data.message !== undefined && data.message !== '')
                          {
                              thisIns.$vs.notify({
                                  title: 'Error',
                                  text: data.message,
                                  color: 'danger',
                                  iconPack: 'feather',
                                  icon: 'icon-alert-circle'
                              });
                          }

                          data = data.data;
                          thisIns.item.keys[data.Sku][index] = data.key;
                          thisIns.popupActive = false;
                          thisIns.popupActive = true;
                      }
                      else {
                          if (data.code === 401) {
                              window.logout();
                          }
                          thisIns.$vs.notify({
                              title: 'Error',
                              text: data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          });
                      }

                      thisIns.$vs.loading.close();
                  });
          },
          openSendedEmailLogPopUp(mailLogs){
            this.sendedEmailLogPopUp = !this.sendedEmailLogPopUp;
            this.mailLogs = mailLogs;
          },
          openSendEmailPopUp(orderId, sendAllByGrouping = false){
              this.sendTokenToEmailPopUp = !this.sendTokenToEmailPopUp;
              this.sendAll = sendAllByGrouping;
              if (sendAllByGrouping){
                  this.sendAllTokenToOrderGroupId = orderId;
              }else{
                  this.sendTokenToOrderId = orderId;
              }
          },
          sendTokenToEmail() {
              this.$vs.loading();
              let thisIns = this;

              let orderId = this.sendTokenToOrderId;
              let url = apiUrl + '/order/' + orderId + '/send?token=' + token;
              if (this.sendAll){
                orderId = this.sendAllTokenToOrderGroupId;
                url = apiUrl + '/order/' + orderId + '/send/all?token=' + token;
              }

              let email = this.sendTokenToEmailValue;

              if (orderId <= 0) return false;

              axios.post(url, {email : email})
                  .then(function (response) {

                      let data = response.data;
                      if (data.code === 200) {
                          thisIns.$vs.notify({
                              title: 'Success',
                              text: 'Email Sent',
                              color: 'success',
                              iconPack: 'feather',
                              icon: 'icon-check'
                          });
                      }
                      else {
                          if (data.code === 401) {
                              window.logout();
                          }
                          thisIns.$vs.notify({
                              title: 'Error',
                              text: data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-circle'
                          });
                      }

                      thisIns.$vs.loading.close();
                  });
          },
      },
      created(){

      },
      mounted() {

      }
  }
</script>

<style scoped lang="scss">
  .textarea {
    color: rgba(var(--vs-primary), 1) !important;
  }

    .vs-popup--content{
        td{
            .returned{
                text-decoration: line-through;
            }
            .returned_pending{
                color: orangered;
                text-decoration: line-through;
            }
        }
    }
</style>
